function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { decode as base64url } from '../../runtime/base64url.js';
import decrypt from '../../runtime/decrypt.js';
import { JOSEAlgNotAllowed, JOSENotSupported, JWEInvalid } from '../../util/errors.js';
import isDisjoint from '../../lib/is_disjoint.js';
import isObject from '../../lib/is_object.js';
import decryptKeyManagement from '../../lib/decrypt_key_management.js';
import { encoder, decoder, concat } from '../../lib/buffer_utils.js';
import generateCek from '../../lib/cek.js';
import validateCrit from '../../lib/validate_crit.js';
import validateAlgorithms from '../../lib/validate_algorithms.js';
export function flattenedDecrypt(_x, _x2, _x3) {
  return _flattenedDecrypt.apply(this, arguments);
}
function _flattenedDecrypt() {
  _flattenedDecrypt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(jwe, key, options) {
    var _jwe$protected;
    var parsedProt, _protectedHeader, joseHeader, alg, enc, keyManagementAlgorithms, contentEncryptionAlgorithms, encryptedKey, resolvedKey, cek, iv, tag, protectedHeader, additionalData, ciphertext, plaintext, result, _t, _t2, _t3, _t4, _t5, _t6, _t7;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (isObject(jwe)) {
            _context.n = 1;
            break;
          }
          throw new JWEInvalid('Flattened JWE must be an object');
        case 1:
          if (!(jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined)) {
            _context.n = 2;
            break;
          }
          throw new JWEInvalid('JOSE Header missing');
        case 2:
          if (!(jwe.iv !== undefined && typeof jwe.iv !== 'string')) {
            _context.n = 3;
            break;
          }
          throw new JWEInvalid('JWE Initialization Vector incorrect type');
        case 3:
          if (!(typeof jwe.ciphertext !== 'string')) {
            _context.n = 4;
            break;
          }
          throw new JWEInvalid('JWE Ciphertext missing or incorrect type');
        case 4:
          if (!(jwe.tag !== undefined && typeof jwe.tag !== 'string')) {
            _context.n = 5;
            break;
          }
          throw new JWEInvalid('JWE Authentication Tag incorrect type');
        case 5:
          if (!(jwe.protected !== undefined && typeof jwe.protected !== 'string')) {
            _context.n = 6;
            break;
          }
          throw new JWEInvalid('JWE Protected Header incorrect type');
        case 6:
          if (!(jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== 'string')) {
            _context.n = 7;
            break;
          }
          throw new JWEInvalid('JWE Encrypted Key incorrect type');
        case 7:
          if (!(jwe.aad !== undefined && typeof jwe.aad !== 'string')) {
            _context.n = 8;
            break;
          }
          throw new JWEInvalid('JWE AAD incorrect type');
        case 8:
          if (!(jwe.header !== undefined && !isObject(jwe.header))) {
            _context.n = 9;
            break;
          }
          throw new JWEInvalid('JWE Shared Unprotected Header incorrect type');
        case 9:
          if (!(jwe.unprotected !== undefined && !isObject(jwe.unprotected))) {
            _context.n = 10;
            break;
          }
          throw new JWEInvalid('JWE Per-Recipient Unprotected Header incorrect type');
        case 10:
          if (!jwe.protected) {
            _context.n = 13;
            break;
          }
          _context.p = 11;
          _protectedHeader = base64url(jwe.protected);
          parsedProt = JSON.parse(decoder.decode(_protectedHeader));
          _context.n = 13;
          break;
        case 12:
          _context.p = 12;
          _t = _context.v;
          throw new JWEInvalid('JWE Protected Header is invalid');
        case 13:
          if (isDisjoint(parsedProt, jwe.header, jwe.unprotected)) {
            _context.n = 14;
            break;
          }
          throw new JWEInvalid('JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint');
        case 14:
          joseHeader = _objectSpread(_objectSpread(_objectSpread({}, parsedProt), jwe.header), jwe.unprotected);
          validateCrit(JWEInvalid, new Map(), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
          if (!(joseHeader.zip !== undefined)) {
            _context.n = 15;
            break;
          }
          throw new JOSENotSupported('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        case 15:
          alg = joseHeader.alg, enc = joseHeader.enc;
          if (!(typeof alg !== 'string' || !alg)) {
            _context.n = 16;
            break;
          }
          throw new JWEInvalid('missing JWE Algorithm (alg) in JWE Header');
        case 16:
          if (!(typeof enc !== 'string' || !enc)) {
            _context.n = 17;
            break;
          }
          throw new JWEInvalid('missing JWE Encryption Algorithm (enc) in JWE Header');
        case 17:
          keyManagementAlgorithms = options && validateAlgorithms('keyManagementAlgorithms', options.keyManagementAlgorithms);
          contentEncryptionAlgorithms = options && validateAlgorithms('contentEncryptionAlgorithms', options.contentEncryptionAlgorithms);
          if (!(keyManagementAlgorithms && !keyManagementAlgorithms.has(alg) || !keyManagementAlgorithms && alg.startsWith('PBES2'))) {
            _context.n = 18;
            break;
          }
          throw new JOSEAlgNotAllowed('"alg" (Algorithm) Header Parameter value not allowed');
        case 18:
          if (!(contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc))) {
            _context.n = 19;
            break;
          }
          throw new JOSEAlgNotAllowed('"enc" (Encryption Algorithm) Header Parameter value not allowed');
        case 19:
          if (!(jwe.encrypted_key !== undefined)) {
            _context.n = 22;
            break;
          }
          _context.p = 20;
          encryptedKey = base64url(jwe.encrypted_key);
          _context.n = 22;
          break;
        case 21:
          _context.p = 21;
          _t2 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the encrypted_key');
        case 22:
          resolvedKey = false;
          if (!(typeof key === 'function')) {
            _context.n = 24;
            break;
          }
          _context.n = 23;
          return key(parsedProt, jwe);
        case 23:
          key = _context.v;
          resolvedKey = true;
        case 24:
          _context.p = 24;
          _context.n = 25;
          return decryptKeyManagement(alg, key, encryptedKey, joseHeader, options);
        case 25:
          cek = _context.v;
          _context.n = 28;
          break;
        case 26:
          _context.p = 26;
          _t3 = _context.v;
          if (!(_t3 instanceof TypeError || _t3 instanceof JWEInvalid || _t3 instanceof JOSENotSupported)) {
            _context.n = 27;
            break;
          }
          throw _t3;
        case 27:
          cek = generateCek(enc);
        case 28:
          if (!(jwe.iv !== undefined)) {
            _context.n = 31;
            break;
          }
          _context.p = 29;
          iv = base64url(jwe.iv);
          _context.n = 31;
          break;
        case 30:
          _context.p = 30;
          _t4 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the iv');
        case 31:
          if (!(jwe.tag !== undefined)) {
            _context.n = 34;
            break;
          }
          _context.p = 32;
          tag = base64url(jwe.tag);
          _context.n = 34;
          break;
        case 33:
          _context.p = 33;
          _t5 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the tag');
        case 34:
          protectedHeader = encoder.encode((_jwe$protected = jwe.protected) !== null && _jwe$protected !== void 0 ? _jwe$protected : '');
          if (jwe.aad !== undefined) {
            additionalData = concat(protectedHeader, encoder.encode('.'), encoder.encode(jwe.aad));
          } else {
            additionalData = protectedHeader;
          }
          _context.p = 35;
          ciphertext = base64url(jwe.ciphertext);
          _context.n = 37;
          break;
        case 36:
          _context.p = 36;
          _t6 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the ciphertext');
        case 37:
          _context.n = 38;
          return decrypt(enc, cek, ciphertext, iv, tag, additionalData);
        case 38:
          plaintext = _context.v;
          result = {
            plaintext: plaintext
          };
          if (jwe.protected !== undefined) {
            result.protectedHeader = parsedProt;
          }
          if (!(jwe.aad !== undefined)) {
            _context.n = 41;
            break;
          }
          _context.p = 39;
          result.additionalAuthenticatedData = base64url(jwe.aad);
          _context.n = 41;
          break;
        case 40:
          _context.p = 40;
          _t7 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the aad');
        case 41:
          if (jwe.unprotected !== undefined) {
            result.sharedUnprotectedHeader = jwe.unprotected;
          }
          if (jwe.header !== undefined) {
            result.unprotectedHeader = jwe.header;
          }
          if (!resolvedKey) {
            _context.n = 42;
            break;
          }
          return _context.a(2, _objectSpread(_objectSpread({}, result), {}, {
            key: key
          }));
        case 42:
          return _context.a(2, result);
      }
    }, _callee, null, [[39, 40], [35, 36], [32, 33], [29, 30], [24, 26], [20, 21], [11, 12]]);
  }));
  return _flattenedDecrypt.apply(this, arguments);
}